//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"BendFaces",0,"ScCollector",0],[0,"CutType",1,0],[1,"Depth",0,"Expression",0],[0,"DepthSide",1,0],[0,"DepthType",1,0],[0,"From",1,"ISurface",0],[0,"Section",1,"Section",0],[0,"SectionSide",1,0],[0,"Sketch",1,"Features.SketchFeature",0],[0,"TargetBody",1,"Body",0],[0,"To",1,"ISurface",0],[0,"Type",1,0]],[[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0]],[]];
SPLM.Features.SheetMetal.NormalCutoutBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.NormalCutoutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.NormalCutoutBuilder.DepthTypeOptions = Object.freeze({
    "Finite" : "Finite", "FromTo" : "FromTo", "ThroughNext" : "ThroughNext", "ThroughAll" : "ThroughAll"});

SPLM.Features.SheetMetal.NormalCutoutBuilder.CutTypeOptions = Object.freeze({
    "ThicknessCut" : "ThicknessCut", "MidPlaneCut" : "MidPlaneCut", "NearestFaceCut" : "NearestFaceCut"});

SPLM.Features.SheetMetal.NormalCutoutBuilder.DepthSideOptions = Object.freeze({
    "SectionNormalSide" : "SectionNormalSide", "SectionReverseNormalSide" : "SectionReverseNormalSide", "Symmetric" : "Symmetric"});

SPLM.Features.SheetMetal.NormalCutoutBuilder.SectionSideOptions = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Features.SheetMetal.NormalCutoutBuilder.TypeOptions = Object.freeze({
    "SketchType" : "SketchType", "NonPlanarCurveType" : "NonPlanarCurveType"});

export default SPLM;